module.exports = __webpack_public_path__ + "static/media/a2.402f9997.png";